module.exports = __webpack_public_path__ + "img/004.28b5a497.png";